<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Template Setting Detail
                  </h6>

                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px"
                  >
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.created_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.updated_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <label for="defaultconfig" class="col-form-label">{{
                            $t("companyTxt")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              forms.company?.code + ' - ' + forms.company?.name
                            "
                            disabled
                          />

                          <div v-if="errors.company_id">
                            <div
                              v-for="error in errors.company_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <label for="defaultconfig" class="col-form-label">{{
                            $t("companyCode")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="code"
                            :placeholder="$t('companyCode')"
                            :value="forms.company?.code"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <label for="defaultconfig" class="col-form-label">{{
                            $t("companyName")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="code"
                            :placeholder="$t('companyName')"
                            :value="forms.company?.name"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <label for="defaultconfig" class="col-form-label">{{
                            $t("sap_code")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="code"
                            :placeholder="$t('sap_code')"
                            :value="forms.company?.sap_code"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <label for="defaultconfig" class="col-form-label">{{
                            $t("piTemplateName")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="template_name"
                            :placeholder="$t('piTemplateName')"
                            :value="forms.template_name"
                            disabled
                          />
                          <div v-if="errors.template_name">
                            <div
                              v-for="error in errors.template_name"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <label for="defaultconfig" class="col-form-label">{{
                            $t("description_txt")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <textarea
                            class="form-control"
                            id="description"
                            :value="forms.description"
                            disabled
                          ></textarea>
                          <div v-if="errors.description">
                            <div
                              v-for="error in errors.description"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <nav>
                      <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                          v-for="(sheet, key) in sheets"
                          :key="key"
                          class="nav-link"
                          data-bs-toggle="tab"
                          role="tab"
                          :id="'nav-' + sheet.detail_name.replaceAll(' ', '_')"
                          :href="'#' + sheet.detail_name.replaceAll(' ', '_')"
                          :class="key == 0 ? 'active' : ''"
                          >{{ sheet.detail_alias }}</a
                        >
                      </div>
                    </nav>
                    <div class="tab-content" id="myTabContent">
                      <div
                        v-for="(sheet, key) in sheets"
                        :key="key"
                        class="tab-pane fade"
                        :id="sheet.detail_name.replaceAll(' ', '_')"
                        role="tabpabel"
                        :aria-labelledby="
                          sheet.detail_name.replaceAll(' ', '_') + '-tab'
                        "
                        :class="key == 0 ? 'active show' : ''"
                      >
                        <div class="col-lg-12 col-xl-12 stretch-card mb-3">
                          <div class="card card-custom">
                            <div class="card-body mt-2">
                              <div class="row">
                                <div class="col-sm-2">
                                  <div class="mb-3">
                                    <label class="form-label">Sheet Name</label>
                                    <input
                                      type="text"
                                      disabled
                                      class="form-control"
                                      :value="sheet.detail_name"
                                      placeholder="Sheet Name"
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Sheet Alias</label
                                    >
                                    <input
                                      type="text"
                                      class="form-control"
                                      disabled
                                      :value="sheet.detail_alias"
                                      placeholder="Sheet Alias"
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Sheet Order</label
                                    >
                                    <input
                                      type="number"
                                      class="form-control"
                                      disabled
                                      :value="sheet.detail_order"
                                      placeholder="Sheet Order"
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-10">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <div class="card">
                                        <div class="card-header">
                                          <h5>Field List</h5>
                                        </div>
                                        <div class="card-body">
                                          <TemplateSettingCustomTable
                                            :rows="sheet.fieldList"
                                            :columns="fieldListColumn"
                                            row-key-field="proforma_invoice_template_field_list_id"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="card">
                                        <div class="card-header">
                                          <h5>Selected Field</h5>
                                        </div>
                                        <div class="card-body">
                                          <TemplateSettingCustomTable
                                            :rows="sheet.field"
                                            :columns="selectedFieldColumn"
                                            sort-field="field_order"
                                            sort-type="asc"
                                          >
                                            <template
                                              slot="cell"
                                              slot-scope="props"
                                            >
                                              <span v-if="props.column.field == 'field_lable'">
                                                {{ props.row?.field?.field_lable }}
                                              </span>
                                              <span v-else-if="props.column.field == 'field_alias'">
                                                <span
                                                  v-show="!props.row.is_edit"
                                                  >{{
                                                    props.row.field_alias
                                                  }}</span
                                                >
                                                <input
                                                  v-show="props.row.is_edit"
                                                  type="text"
                                                  v-model="
                                                    props.row.field_alias_temp
                                                  "
                                                  class="form-control"
                                                />
                                              </span>
                                              <span
                                                v-else-if="
                                                  props.column.field ==
                                                  'required'
                                                "
                                              >
                                                <input
                                                  type="checkbox"
                                                  :checked="
                                                    props.row.required === '1'
                                                      ? true
                                                      : false
                                                  "
                                                  disabled
                                                />
                                              </span>
                                              <span v-else>
                                                {{ props.value }}
                                              </span>
                                            </template>
                                          </TemplateSettingCustomTable>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-warning text-black fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>
                  <a
                    v-if="permision_role.method_delete"
                    class="btn btn-danger text-white fw-bolder btn-icon-text float-end"
                    @click="deleteData()"
                  >
                    <i class="link-icon" data-feather="trash"></i>
                    {{ $t("deleteMess") }}
                  </a>

                  <a
                    v-if="permision_role.method_update"
                    class="btn btn-primary me-2 text-white fw-bolder btn-icon-text float-end"
                    @click="editData()"
                  >
                    <i class="link-icon" data-feather="edit"></i>
                    {{ $t("editMess") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import TemplateSettingCustomTable from "@/components/proformaInvoice/templateSetting/TemplateSettingCustomTable.vue";
export default {
  name: "TemplateSettingIndex",
  computed: {
    fieldListColumn() {
      return [
        {
          label: "Field Name",
          field: "field_lable",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Field Description",
          field: "field_description",
          headerClass: "template-setting-col-description",
          cellClass: "template-setting-col-description",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ];
    },
    selectedFieldColumn() {
      return [
        {
          label: "Field Name",
          field: "field_lable",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
          sortable: false,
        },
        {
          label: "Req ?",
          field: "required",
          sortable: false,
        },
        {
          label: "Field Alias",
          field: "field_alias",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
          sortable: false,
        },
        {
          label: "Sort",
          field: "field_order",
          sortable: false,
        },
      ];
    },
  },
  props: {},
  components: {
    sidebarComponent,
    navbarComponent,
    footerComponent,
    TemplateSettingCustomTable,
  },
  data() {
    return {
      closeBtn: true,
      permision_role: [],
      isLoading: false,
      errors: [],
      forms: {},
      sheets: [],
      fetchFieldList: [],
    };
  },
  watch: {},
  methods: {
    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI = this.$settings.endPointProformaInvoice + "v1/template-pi/delete/" + id;
          this.$http
            .delete(baseURI)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/proforma-invoice/template-setting";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },
    editData() {
      var params = this.$route.params.id;
      window.location.href =
        "/proforma-invoice/template-setting/edit/" + params;
    },
    backForm() {
      window.location.href = "/proforma-invoice/template-setting";
    },
    async loadFieldList() {
      const baseURI =
        this.$settings.endPointProformaInvoice +
        `v1/template-pi/get-available-field`;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFieldList = response.data.datas;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadData() {
      var id = this.$onBehind(this.$route.params.id)[0];
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice + `v1/template-pi/detail/${id}`;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.forms = response.data.datas;
          this.sheets = this.forms.detail;
          this.sheets.forEach((item) => {
            this.$set(item, "field", item.detail_field);
            this.$set(item, "fieldList", this.fetchFieldList);
            this.$delete(item, "detail_field");
          });

          console.log(this.sheets);
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "TemplatePIController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      this.$toast.error(kata, { position: "top-right" });
    },
    
    fade(sType) {
      this.isLoading = sType;
    },
    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },
  },
  async mounted() {
    this.fetchIt();
    await this.loadFieldList();
    this.loadData();
  },
  created() {},
};
</script>
<style></style>
